/**
* 统计数据公用方法
*/
import Ls from '@/config/storage'


/*const fs = require('fs');
let options = {
  flags: 'a', //
  encoding: 'utf8', // utf8编码
}
let stderr = fs.createWriteStream('./a.log', options);

// 创建logger
let logger = new console.Console(stderr);

fs.writeFile('./a.log', '', function (err) {
  if(err){
    console.log(err);
  }
});

logger.log('这是一条日志1');
logger.log('这是一条日志2');*/
export default {
    //补零
    mDug(n){
        if(typeof (n) != "number"){
            n=parseInt(n);
        }

        if(n<10){
            return "0"+n;
        }else {
            return ""+n;
        }
    },
    //返回当前时间
    mNowDate(){
        var myDate = new Date();
        var nowDate=myDate.getFullYear()+"-"+this.mDug(myDate.getMonth()+1)+"-"+this.mDug(myDate.getDate())+" "+this.mDug(myDate.getHours())+":"+this.mDug(myDate.getMinutes())+":"+this.mDug(myDate.getSeconds());
        return nowDate;
    },
    //判断教学课件
    returnJxkj(list){
        /*var list = [{"resourceClassicsId":"8","resourceClassicsName":"教案","resourceClassicsLogo":"","resourceClassicsDesc":null,"courseResourceList":[{"courseResourceId":"6385","courseResourceName":"活动1 喝水啦！教案","courseResourceUrl":"https://7nkcpt.o-star.cc/BLYD/e31e257168a8a5345ecec18dd26babde/活动1 喝水啦！教案.pdf","courseResourceExt":"pdf","courseResourceDesc":null}]},{"resourceClassicsId":"9","resourceClassicsName":"教学课件","resourceClassicsLogo":"","resourceClassicsDesc":null,"courseResourceList":[{"courseResourceId":"6426","courseResourceName":"1-a-hsl","courseResourceUrl":"https://7nkcpt.o-star.cc/BLYD/fb62420011ce10286c9d2f7cc8fe612b/1-a-hsl.html","courseResourceExt":"html","courseResourceDesc":null}]}];*/
        for(var i=0,len=list.length;i<len; i++){
            var item = list[i];
            if(item.resourceClassicsName.indexOf('教学课件')!==-1){
                return item;
            }
        }
        return null;
    },
    //设置缓存数据
    setPlan(name,data){
        for(var key in data){
            if(key == "Time"){
                // console.log("setPlan:time")
                this.addDate(name,data[key]);
            }else{
              // console.log("setPlan:其他")
                this.upData(name,{
                    title:key,
                    value:data[key]
                })
            }
        }

    },
    setPlanList(json){
        for(var i=0;i<json.list; i++){
            this.setPlan(json.list[i].title,json.list[i].value)
        }
    },
    //加时间
    addDate(name,value){
      if(!Ls.getItem(name)){
        return;
      }

        var localData=Ls.getItem(name) || {};
      // console.log("获取localdate: "+value,name,localData)

        var time=null;
        //如果是课件
        if(name.indexOf('planCensus') != -1){
            if(localData.kjData){
            time= parseInt(localData.kjData.Time)+value;
            }
        }else{
            time= parseInt(localData.Time)+value;
          // console.log(" parseInt(localData.Time)="+time,parseInt(localData.Time),value)
        }

        // time = this.mSecondsToMakeDuration(time);
        this.upData(name,{
            title:"Time",
            value:time
        })
    },
    //web加时间
    addDateWeb(json){
      if(!Ls.getItem(json.key)){
        return;
      }
        var name=json.name || "updateTime";
        var value=json.value || 1;
        var key=json.key;
        var index = json.index;
        var localData=Ls.getItem(key).unitContent[index];
        var time=null;
        time= parseInt(localData[name][0])+value;
        // time = this.mSecondsToMakeDuration(time);
        this.upDataWeb(key,{
            title:name,
            value:time,
            index:index
        })
    },
    //更新某个值 web格式
    upDataWeb(name,json){
        var title = json.title;
        var value = json.value;
        var index = json.index;
        var localData=Ls.getItem(name);
        //如果是课件
        if(title == "updateTime"){
            var arr=[];
            arr[0]=value;
            localData.unitContent[index][title]=arr;
        }else{
            localData[title]=value;
        }
        Ls.setItem(name,localData);
    },
    //更新某个值
    upData(name,json){
      // console.log("upData",name,json)
        var title=json.title;
        var value=json.value;
        var localData=Ls.getItem(name) || {};
        if(json.title == "Time"){
          // console.log(json.title+"的输出console",name,Ls.getItem(name))
        }
        //如果是课件
        if(name.indexOf('planCensus') != -1){
            localData.kjData[title]=value;
        }else{
          // console.log("localData[title]=value",localData[title],value)
            localData[title]=value;
        }
        // console.log("最后存储的数据",localData)
        Ls.setItem(name,localData);
    },
    //时间转换
    mMakeDurationToSeconds(t){
    var t=(t).toString();
    if(t.indexOf(":") != -1){
        var t1M=t.split(":");
        if(t1M.length == 3){
            //时分秒
            var hs = parseInt(parseInt(t1M[0])*3600);
            var ms = parseInt(parseInt(t1M[1])*60);
            var ss = parseInt(t1M[2]);
            var seconds = hs + ms + ss;
            return seconds;
        }else if(t1M.length == 2){
            //分秒
            var ms = parseInt(parseInt(t1M[0])*60);


            var ss = parseInt(t1M[1]);
            var seconds = ms + ss;

            return seconds;
        }

    }else{
        return parseInt(t);
    }
},
    //时间转化
    mSecondsToMakeDuration(t){
        // if(t >= 3600){
            var duration1=parseInt(t/3600);
            var duration2=parseInt(parseInt(t%3600)/60);
            var duration3=t-(duration1*3600)-(duration2*60);

            return this.mDug(duration1)+":"+this.mDug(duration2)+":"+this.mDug(duration3);
        // }else{
        //     var duration2=parseInt(t/60);
        //     var duration3=t-(duration2*60);
        //
        //     return this.mDug(duration2)+":"+this.mDug(duration3);
        // }
    },
    //统一时分秒
    durationToMakeHour(t){
        var len = 8;
        var length = len - t.length;
        if(length == 3){
            t="00:"+t
        }

        return t;
    },
}



// WEBPACK FOOTER //
// ./src/config/log.js